import SearchBox from "@/components/Search/SearchBox/SearchBox.vue";
import ClickOutside from "@/components/ClickOutside/ClickOutside.vue";
import { root } from "@/common/consts";
import { detailPageNavigation as menu } from "@/common/navigation";
import { mapGetters } from "vuex";
import { getCurrentSubdomain } from "@/common/functions";

export default {
    components: {
        SearchBox,
        BurgerButton: () =>
            import(
                /* webpackChunkName: "burgerButton" */ "@/components/BurgerButton/BurgerButton.vue"
            ),
        ResultTabs: () =>
            import(/* webpackChunkName: "resultTabs" */ "@/components/ResultTabs/ResultTabs.vue"),
        MainNavigation: () =>
            import(
                /* webpackChunkName: "mainNavigation" */ "@/components/MainNavigation/MainNavigation.vue"
            ),
        LanguageSwitcher: () =>
            import(
                /* webpackChunkName: "languageSwitcher" */ "@/components/LanguageSwitcher/LanguageSwitcher.vue"
            ),
        ClickOutside,
        LoginProfile: () =>
            import(
                /* webpackChunkName: "loginProfile" */ "@/components/LoginProfile/LoginProfile.vue"
            )
    },
    computed: {
        ...mapGetters(["currentLanguage"]),
        isResultTabsVisible() {
            const articleSubdomains = [
                "abbreviations",
                "esl",
                "grammar",
                "reference",
                "education",
                "examples"
            ];

            return (
                this.currentLanguage === "en" &&
                !articleSubdomains.includes(this.currentSubdomain) &&
                !this.isIndexPage &&
                !this.isNoResultsPage &&
                !this.isLandingPage
            );
        },
        isSearchBoxVisible() {
            return (
                (this.currentLanguage === "en" && this.currentSubdomain === "abbreviations") ||
                this.isDetailPage ||
                this.isIndexPage ||
                !this.isLandingPage
            );
        }
    },
    data() {
        return {
            openNav: false,
            menu,
            enLink: `${root.WWW}/`,
            esLink: `${root.ES}/`,
            currentSubdomain: getCurrentSubdomain(),
            isIndexPage: false,
            isNoResultsPage: false,
            isLandingPage: false,
            isDetailpage: false,
            currentPage: window.location.pathname
        };
    },
    methods: {
        onBurgerClick(state) {
            this.openNav = state;
            document.body.classList.toggle("locked");
        }
    },
    mounted() {
        this.isIndexPage = /^\/index/.test(window.location.pathname);
        this.isNoResultsPage = /^\/404\/no-results/.test(window.location.pathname);
        this.isLandingPage = window.location.pathname.split("/")[1] === "" ? true : false;
        this.isDetailPage =
            window.location.pathname.split("/")[1] !== "" &&
            window.location.pathname.split("/")[1] !== "index"
                ? true
                : false;
    }
};



// WEBPACK FOOTER //
// ./src/components/SearchResultsHeader/SearchResultsHeader.js